import { render, staticRenderFns } from "./BillingOrderConcessionPage.vue?vue&type=template&id=23ec4e18&scoped=true"
import script from "./BillingOrderConcessionPage.vue?vue&type=script&lang=js"
export * from "./BillingOrderConcessionPage.vue?vue&type=script&lang=js"
import style0 from "./BillingOrderConcessionPage.vue?vue&type=style&index=0&id=23ec4e18&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ec4e18",
  null
  
)

export default component.exports